((app, ng) => {

    app.component("fundingSources",
        {
            templateUrl: "/App/Client/Case/Accounts/FundingSources/funding-sources.html",
            controller: fundingSourcesController,
            bindings: {
                insuranceAccountId: "<",
                investmentAccountId: "<",
                fundingSources: "<",
                taxQualifications: "<",
                planTypes: "<",
            }
        });

    function fundingSourcesController(caseModalService, fundingSourceApi) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.defaultSource = {
                InsuranceAccountId: $ctrl.insuranceAccountId,
                InvestmentAccountId: $ctrl.investmentAccountId,
            }
        }

        const editFundingSource = (source, $event) => {
            caseModalService.openEditFundingSource({ ...source }, $ctrl.planTypes, $ctrl.taxQualifications, $event)
                .then(response => {
                    if (!!response) {
                        switch (response.evt) {
                        case "FUNDING_SOURCE_CREATED":
                            $ctrl.fundingSources.push(response.source);
                            break;
                        case "FUNDING_SOURCE_UPDATED":
                            source = Object.assign(source, response.source);
                            break;
                        }
                    }
                });
        }

        const deleteFundingSource = (sourceId, $event) => {
            caseModalService.confirmFundingSourceDeletion($event).then(() => {
                $ctrl.fundingSources.splice(1, $ctrl.fundingSources.findIndex(source => source.Id === sourceId));

                fundingSourceApi.deleteFundingSource(sourceId);
            });
        }

        const getTotalEstimatedPremium = (fundingSources) => {
            return fundingSources.reduce((total, source) => total + source.EstimatedAmount, 0);
        }

        const getTotalIssuedPremium = (fundingSources) => {
            return fundingSources.reduce((total, source) => total + source.ActualAmount, 0);
        }

        ng.extend($ctrl,
            {
                editFundingSource,
                deleteFundingSource,
                getTotalEstimatedPremium,
                getTotalIssuedPremium,
            });
    }

})(window.app, window.angular);